const pagination = {
  total: 0,
  limit: 20,
  page: 0,
  pages: 0,
}

export default {
  pagination,
}



// WEBPACK FOOTER //
// ./src/fixtures/index.js